export default __webpack_public_path__ + "static/media/addpermission-aqua.4e9e1841.svg";